import "./VerticalLifecycle.css";

import { useMemo } from "react";

import { CompletedCircleGreenIcon, InProgressCircleGreenIcon, NotStartedCircleGreyIcon } from "../../../../assets";
import { ProjectStatusConstants } from "../../../../constants";

interface VerticalLifecycleProps {
  currentStatus?: string;
}

export const VerticalLifecycle = ({ currentStatus }: VerticalLifecycleProps): JSX.Element => {
  const steps = useMemo(() => {
    return currentStatus === ProjectStatusConstants.DRAFT || currentStatus === ProjectStatusConstants.PRE_DEVELOPMENT
      ? [
          ProjectStatusConstants.DRAFT,
          ProjectStatusConstants.PRE_DEVELOPMENT,
          ProjectStatusConstants.UNDER_DEVELOPMENT,
          ProjectStatusConstants.VALIDATED,
          ProjectStatusConstants.VERIFIED,
        ]
      : [ProjectStatusConstants.UNDER_DEVELOPMENT, ProjectStatusConstants.VALIDATED, ProjectStatusConstants.VERIFIED];
  }, [currentStatus]);

  const currentStepIndex = currentStatus ? steps.indexOf(currentStatus) : 0;

  return (
    <>
      {steps.map((step, index) => (
        <div key={step} className="LifecycleStep">
          <div className="LifecycleStepColumn">
            {currentStatus === ProjectStatusConstants.VALIDATED || currentStatus === ProjectStatusConstants.VERIFIED
              ? (index <= currentStepIndex && <CompletedCircleGreenIcon />) ||
                (index === currentStepIndex + 1 && <InProgressCircleGreenIcon />) ||
                (index > currentStepIndex && <NotStartedCircleGreyIcon />)
              : (index < currentStepIndex && <CompletedCircleGreenIcon />) ||
                (index === currentStepIndex && <InProgressCircleGreenIcon />) ||
                (index > currentStepIndex && <NotStartedCircleGreyIcon />)}
            {index !== steps.length - 1 && (
              <div
                className={`LifecycleStepDivider ${
                  index < currentStepIndex ? "LifecycleStepDivider_completed" : "LifecycleStepDivider_not-started"
                }`}
              />
            )}
          </div>
          <div className="LifecycleStepLabel">
            <span className="body2">{step}</span>
          </div>
        </div>
      ))}
    </>
  );
};
